<template>
    <va-edit-layout>
        <PayWithAmazonEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></PayWithAmazonEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
